export const apiConstants = {
    API: 'API'
};



// WEBPACK FOOTER //
// ./src/redux/constants/api.constants.js